(function () {
  var syncing = false;

  function stateForCount(count) {
    if (count >= 4) {
      return {
        pct: 100,
        active: 3,
        message: "You've unlocked <strong>20% off</strong>!",
      };
    }
    if (count === 3) {
      return {
        pct: 66,
        active: 2,
        message: 'Add <strong>1</strong> more item to get an extra <strong>20% off</strong>!',
      };
    }
    if (count === 2) {
      return {
        pct: 33,
        active: 1,
        message: 'Add <strong>1</strong> more item to get an extra <strong>15% off</strong>!',
      };
    }
    if (count === 1) {
      return {
        pct: 16,
        active: 0,
        message: 'Add <strong>1</strong> more item to get an extra <strong>10% off</strong>!',
      };
    }
    return {
      pct: 0,
      active: 0,
      message: 'Add <strong>2</strong> items to get an extra <strong>10% off</strong>!',
    };
  }

  function readCount(root) {
    var attr = parseInt(root.getAttribute('data-item-count'), 10);
    if (!isNaN(attr)) return attr;
    var bubble = document.querySelector(
      '.cart-count-bubble span[aria-hidden], #cart-icon-bubble .visually-hidden'
    );
    if (bubble) {
      var n = parseInt((bubble.textContent || '').replace(/[^\d]/g, ''), 10);
      if (!isNaN(n)) return n;
    }
    return 0;
  }

  function updateCartTier(root) {
    if (!root) return;
    var count = readCount(root);
    var state = stateForCount(count);
    var nextCount = String(count);
    // setAttribute with the same value still fires MutationObserver — only write on change.
    if (root.getAttribute('data-item-count') !== nextCount) {
      root.setAttribute('data-item-count', nextCount);
    }

    var track = root.querySelector('.cart-tier__track');
    if (track) track.style.setProperty('--cart-tier-progress', state.pct + '%');

    var message = root.querySelector('.cart-tier__message');
    if (message && message.innerHTML !== state.message) {
      message.innerHTML = state.message;
    }

    root.querySelectorAll('.cart-tier__milestone').forEach(function (node, index) {
      var shouldActive = index < state.active;
      if (node.classList.contains('is-active') !== shouldActive) {
        node.classList.toggle('is-active', shouldActive);
      }
    });
  }

  function syncAll() {
    if (syncing) return;
    syncing = true;
    try {
      document.querySelectorAll('[data-cart-tier-progress]').forEach(updateCartTier);
    } finally {
      syncing = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    // childList only: watching attributes caused an infinite loop because
    // updateCartTier writes data-item-count/class inside the drawer.
    new MutationObserver(syncAll).observe(drawer, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('cart:updated', syncAll);
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count =
        event && event.cartData && typeof event.cartData.item_count === 'number'
          ? event.cartData.item_count
          : null;
      document.querySelectorAll('[data-cart-tier-progress]').forEach(function (root) {
        if (count !== null) {
          var nextCount = String(count);
          if (root.getAttribute('data-item-count') !== nextCount) {
            root.setAttribute('data-item-count', nextCount);
          }
        }
        updateCartTier(root);
      });
    });
  }
})();
